module.exports = __webpack_public_path__ + "img/component-settings-light-01.e54b1572.jpg";